import React, { Component } from "react";
import { connect } from "dva";
import { Form, Button, Icon, message, Spin } from "antd";
import moment from "moment";
import SelectUserV4 from "nbugs-select-user-result-v4.0";
import Container from "../../../../components/Container";
import FormCreate from "../../../../components/FormCreate/index";
import TimeRangePicker from "../Components/TimeRangePicker/index";
import ListenClassModal from "../Components/ListenClassModal";
import styles from "./index.less";

const { FormTitle, DateAndTime, FormSelect, SelectUserVersion4 } = FormCreate;

const formItemLayout = {
  labelCol: {
    xs: { span: 3, offset: 0 },
    sm: { span: 3, offset: 0 },
    md: { span: 3, offset: 0 },
    lg: { span: 3, offset: 0 },
    xl: { span: 3, offset: 0 }
  },
  wrapperCol: {
    xs: { span: 18, offset: 0 },
    sm: { span: 18, offset: 0 },
    md: { span: 18, offset: 0 },
    lg: { span: 18, offset: 0 },
    xl: { span: 18, offset: 0 }
  }
};

// @Form.create({
//   onValuesChange: (props, changedFields, allFields) =>
//     that.handleFormValuesChange(allFields)
// })
@Form.create()
@connect(({ user, createLesson, doubleTeacherGlobal }) => ({
  currentUser: user.currentUser,
  formData: createLesson.formData,
  curseList: doubleTeacherGlobal.curseList,
  classRoomList: doubleTeacherGlobal.classRoomList,
  spinProps: createLesson.spinProps
}))
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeError: false,
      showListenModal: false,
      nowRegionOrgId: "",
      nowRegionName: "",
      regionList: [],
      regionRoomError: false
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: "doubleTeacherGlobal/fetchClassRoomList"
    });
    dispatch({
      type: "doubleTeacherGlobal/fetchCurseList"
    });
  }

  // 表单检测
  handleCheckForm = () => {
    const { form } = this.props;
    const { validateFields } = form;
    const haveTime = this.handleCheckTime();
    const haveRegionRoom = this.handleCheckRegionRoom();
    validateFields((errors, values) => {
      if (!errors && haveTime && !haveRegionRoom) {
        const { startTime, liveDate } = values;
        const nowTime = moment().format("HHmmss");
        if (
          moment(startTime).format("HHmmss") < nowTime &&
          moment().format("YYYYMMDD") === moment(liveDate).format("YYYYMMDD")
        ) {
          message.error("开始时间应大于当前时间，请重新选择上课时间");
        } else {
          this.handleCreateLesson(values);
        }
      } else {
        return null;
      }
    });
  };

  // 创建课程
  handleCreateLesson = values => {
    const { regionList, nowRegionOrgId, nowRegionName } = this.state;
    const { dispatch } = this.props;
    const { startTime, endTime, liveDate } = values;
    dispatch({
      type: "createLesson/fetchCreateLesson",
      params: {
        ...values,
        startTime: moment(startTime).format("HH:mm:ss"),
        endTime: moment(endTime).format("HH:mm:ss"),
        liveDate: moment(liveDate).format("YYYY.MM.DD"),
        regionList,
        regionOrgId: nowRegionOrgId,
        regionName: nowRegionName
      }
    });
  };

  // 检测时间是否填写完整
  handleCheckTime = () => {
    const { form } = this.props;
    const { getFieldsValue } = form;
    const { startTime, endTime, liveDate } = getFieldsValue();
    if (!!startTime && !!endTime && !!liveDate) {
      this.setState({
        timeError: false
      });
    } else {
      this.setState({
        timeError: true
      });
    }
    return !!startTime && !!endTime && !!liveDate;
  };

  // 检测听课教室是否选择
  handleCheckRegionRoom = () => {
    const { regionList } = this.state;
    if (!regionList || regionList.length === 0) {
      this.setState({
        regionRoomError: true
      });
    } else {
      this.setState({
        regionRoomError: false
      });
    }
    return !regionList || regionList.length === 0;
  };

  // 表单任意值更改时的回调
  // handleFormValuesChange = allFields => {
  //   const { startTime, endTime, liveDate } = allFields;
  //   if (!!startTime && !!endTime && !!liveDate) {
  //     this.setState({
  //       timeError: false
  //     });
  //   } else {
  //     this.setState({
  //       timeError: true
  //     });
  //   }
  // };

  // 重置听课教室
  handleResetRegionList = () => {
    this.setState({
      regionList: []
    });
  };

  // 选中某个教室之后保存key值
  handleSetSelectClassRoomKey = (value, key, children) => {
    const { regionList } = this.state;
    const tempRegionList = [];
    regionList.forEach(item => tempRegionList.push(item));
    const i = tempRegionList.findIndex(item => item.supplierRegionId === value);
    if (i !== -1) {
      tempRegionList.splice(i, 1);
      message.warning("听课教室与主教室冲突，已移除冲突听课教室");
    }
    this.setState({
      nowRegionOrgId: key,
      nowRegionName: children,
      regionList: tempRegionList
    });
  };

  // 展示听课教室弹框
  handleShowListenModal = () => {
    this.setState({
      showListenModal: true
    });
  };

  // 听课教室弹框确定的回调
  handleListenModalOk = regionList => {
    this.setState({
      regionList
    });
    this.handleCloseListenModal();
  };

  // 关闭听课教室弹框
  handleCloseListenModal = () => {
    this.setState({
      showListenModal: false
    });
  };

  // 框架底部按钮渲染
  renderFooter = () => {
    const footerParams = {
      states: !0,
      demFooter: (
        <>
          <Button
            type="primary"
            onClick={() => {
              this.handleCheckForm();
            }}
          >
            确定
          </Button>
        </>
      )
    };
    return footerParams;
  };

  // 选中听课教室之后的回调
  renderSelectedRegionList = () => {
    const { regionList } = this.state;

    return (
      <div className="regionListContainer">
        <div className="headerContainer">
          <div className="title">已选教室({regionList.length})</div>
          <div className="editContainer">
            <div className="edit" onClick={this.handleShowListenModal}>
              <Icon type="edit" />
              修改
            </div>
            <div className="delete" onClick={this.handleResetRegionList}>
              <img
                src="https://s.xiaoyuanhao.com/file/c79d53b8-8fc4-4f26-8bb8-5f1d012800d2.svg"
                alt=""
              />{" "}
              删除
            </div>
          </div>
        </div>
        <div className="bodyContainer">{this.renderRegionItemContainer()}</div>
      </div>
    );
  };

  // 渲染每个听课教室
  renderRegionItemContainer = () => {
    const { regionList } = this.state;
    return regionList.map((item, number) => {
      const selectUserProps = {
        selectType: "user",
        strictOrgRel: false,
        showTabList: [
          "dept",
          "innerContacts",
          "group",
          "schoolContacts",
          "orgRel"
        ],
        dialogProps: {
          title: "选择辅助教师"
        },
        searchPlaceholder: "搜索辅助教师",
        selectSignature: item.selectId,
        isSaveSelectSignature: true,
        requestParams: {
          selectTypeList: ["user"]
        }
      };
      return (
        <div className="regionItemContainer">
          <div className="lessonTitle">听课教室{number + 1}</div>
          <div className="resultContainer">
            <div className="lessonResult">
              <span>听课教室：</span>
              {item.regionName}
            </div>
            {item.selectId && (
              <div className="teacherResult">
                <span>辅助教师：</span>
                <SelectUserV4 selectUserProps={selectUserProps} />
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  // 上课时间部分的表单
  renderClassTimeForm = () => {
    const { timeError, regionRoomError } = this.state;
    const { form } = this.props;

    const classDateProps = {
      value: "",
      keyName: "liveDate",
      label: "上课时间",
      form,
      itemFormProps: { ...formItemLayout, style: { marginBottom: 24 } },
      datePickerFormat: "YYYY.MM.DD",
      message: "请选择上课日期",
      myRules: [
        {
          required: false,
          message: "请选择上课时间"
        }
      ]
    };

    const timeRangePickerProps = {
      start: "",
      end: "",
      form
    };

    return (
      <div className="classTimeContainer">
        {regionRoomError && (
          <div className="regionRoomErrorTips">请选择听课教室</div>
        )}
        <DateAndTime {...classDateProps} />
        <Form.Item label="上课时间" {...formItemLayout}>
          <TimeRangePicker {...timeRangePickerProps} />
        </Form.Item>
        {timeError && <div className="timerErrorTips">请选择完整的时间</div>}
      </div>
    );
  };

  renderBodyForm = () => {
    const { regionList } = this.state;
    const { form, classRoomList, curseList } = this.props;
    const { getFieldsValue } = form;

    const lessonNameProps = {
      form,
      value: "",
      label: "课程名称",
      keyName: "lessonName",
      maxLength: 100,
      suffix: `${(getFieldsValue().lessonName &&
        getFieldsValue().lessonName.length) ||
        0}/100`
    };

    const subjectProps = {
      form,
      label: "学科",
      value: undefined,
      keyName: "courseName",
      placeholder: "请选择",
      optionData: curseList,
      isRequired: true,
      selfValue: "courseName",
      selfLabel: "courseName"
    };

    const classRoomProps = {
      form,
      value: undefined,
      label: "主讲教室",
      keyName: "supplierRegionId",
      placeholder: "请选择",
      optionData: classRoomList,
      isRequired: true,
      selfValue: "supplierRegionId",
      selfLabel: "regionName",
      selfKey: "regionOrgId",
      onSelect: (value, option) => {
        const { key, props } = option;
        const { children } = props;
        this.handleSetSelectClassRoomKey(value, key, children);
      }
    };

    const mainTeacherProps = {
      form,
      value: "",
      label: "主讲教师",
      message: "请选择主讲教师",
      keyName: "selectId",
      isRequired: true,
      itemFormProps: { style: { marginBottom: 24 } },
      selectProps: {
        multiple: false,
        selectType: "user",
        strictOrgRel: false,
        showTabList: [
          "dept",
          "innerContacts",
          "group",
          "schoolContacts",
          "orgRel"
        ],
        dialogProps: {
          title: "选择主讲教师"
        },
        searchPlaceholder: "搜索主讲教师",
        selectSignature: "",
        isSaveSelectSignature: true,
        requestParams: {
          selectTypeList: ["user"]
        }
      }
    };

    // const formTimeProps = {
    //   onChange: this.triggerChangeTime
    // };

    return (
      <FormCreate onValuesChange={this.handleFormValuesChange}>
        <FormTitle {...lessonNameProps} />
        <FormSelect {...subjectProps} />
        <FormSelect {...classRoomProps} />
        <SelectUserVersion4 {...mainTeacherProps} />
        <Form.Item label="听课教室" className="listenClassRoom" required>
          {regionList && regionList.length ? (
            this.renderSelectedRegionList()
          ) : (
            <Button onClick={this.handleShowListenModal}>选择</Button>
          )}
        </Form.Item>
        <Form.Item label="上课时间" required>
          {this.renderClassTimeForm()}
        </Form.Item>
      </FormCreate>
    );
  };

  render() {
    const { showListenModal, regionList } = this.state;
    const { classRoomList, form, spinProps } = this.props;
    const supplierRegionId = form && form.getFieldValue("supplierRegionId");

    const selectRoomList = classRoomList?.filter(
      item => item.supplierRegionId !== supplierRegionId
    );

    const listenModalProps = {
      visible: showListenModal,
      onCancel: this.handleCloseListenModal,
      onOk: this.handleListenModalOk,
      regionList,
      selectRoomList,
      formItemLayout
    };
    return (
      <Container
        breStates={!0}
        version={2}
        defaultPadding
        isPathParams
        footerParams={this.renderFooter()}
      >
        <Spin {...spinProps}>
          <div className={styles.root}>
            <div className="topTitle">新增课堂</div>
            {this.renderBodyForm()}
          </div>
          {showListenModal && <ListenClassModal {...listenModalProps} />}
        </Spin>
      </Container>
    );
  }
}

export default index;
